import { useEffect, useState } from 'react';
import Toast, { ToastTypes } from '../../molecules/toast/Toast';
import styles from './Notifications.module.css';
import NotificationsEventManager, { NotificationEventData } from './NotificationsEventManager';

const notifications = NotificationsEventManager.create<NotificationEventData>('notifications');
type NotificationsComponent = () => JSX.Element;

const Notifications = () => {
    const [toasts, setToasts] = useState<NotificationEventData[]>([]);

    const updateToasts = () => {
        setToasts([...notifications.notifications]);
    }

    useEffect(() => {
        notifications?.addListener(updateToasts);

        return () => {
            notifications?.removeListener(updateToasts);
        }
    }, [])

    return (
        <div className={styles.Notifications}>
            {toasts?.map((toast) => {
                return (
                    <Toast 
                        key={toast.id}
                        id={toast.id || Date.now.toString()} 
                        type={toast.type as ToastTypes} 
                        heading={toast.heading} 
                        message={toast.message} 
                        customButton={toast.customButton}
                        sticky={toast.sticky}
                    />
                );
            })}
        </div>
    )
}

Object.assign(Notifications, notifications);
export default (Notifications as NotificationsComponent & NotificationsEventManager<NotificationEventData>);
